var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-center"},[_c('el-carousel',{staticClass:"carousel"},_vm._l((_vm.tableData),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"carouselImg",attrs:{"src":item.img,"alt":"","srcset":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }